
import {getWeixinLoginUrl} from '@/api/server/wechat'

export default {
  name: 'WechatOauthPage',
  mixins: [],
  data () {
    return {
        url: null,
        info: null
    }
  },
  components: {
  },
  computed: {
  },
  methods: {
    _getWeixinLoginUrl () {
      let query = {
        url: this.url
      }
      getWeixinLoginUrl(query).then( (res) => {
        if (res.code === 200) {
          window.location.href = decodeURIComponent(res.data.url)
        }
      })
    },
    reset () {
      this._getWeixinLoginUrl()
    },
    handleRoute (route) {
      if (route.name === 'wechat-oauth') {
        let url = (window.location.protocol + '//' + window.location.hostname) + '/wechat/user'
        // if (this.$route.query.url) {
        //   url = url + this.$route.query.url
        // }
        this.url = url
        console.log('url', this.url)
        this.reset()
      }
    }
  },
  watch: {
    '$route' (to, from) {
      this.handleRoute(to)
    }
  },
  mounted: function () {
    this.handleRoute(this.$route)
  }
  
}